<h1 mat-dialog-title class="text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="mt-3 wid">
    <div class="col-md-12 mb-2">
      <label for="paymentDate" class="payingClinic col-md-6 required">Payment Date</label>
      <my-date-picker class="col-md-6 d-inline-block text-center payDate" name="paymentDate"
        [options]="myDatePickerOptions" [(ngModel)]="paymentDate" (dateChanged)="onPaymentDateChanged($event)"
        placeholder="Payment Date">
      </my-date-picker>
    </div>
    <div class="col-md-12 mb-2">
      <label for="paymentReferenceNo" class="payingClinic col-md-6 required">Reference No</label>
      <input type="text" class="form-control d-inline-block input-font inputBox col-md-6" id="paymentReferenceNo"
        [(ngModel)]="paymentReferenceNo">
    </div>
    <div class="col-md-12 mb-2">
      <label for="paidAmount" class="payingClinic col-md-6 required">Amount</label>
      <input type="text" class="form-control d-inline-block input-font inputBox col-md-6" readonly id="paidAmount"
        [(ngModel)]="paidAmount">
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <div class="row col-md-12 ml-3 justify-content-center">
    <button mat-button class="mat-raised-button mr-4 btn blankTurquoise btnWidth"
      (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button d-inline-block btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="updatePayment()">Update Payment</button>
  </div>
</mat-dialog-actions>
